import React from 'react';

type ImpactSection = Record<string, string | number>;

type Props = {
  willRemove: ImpactSection;
  willKeep: ImpactSection;
};

function formatImpactKey(key: string): string {
  return key.replace(/_/g, ' ');
}

/** Read-only deletion impact summary — not interactive; confirm button is the only action. */
export default function RemovalSummaryPanel({ willRemove, willKeep }: Props) {
  return (
    <div className="removal-summary">
      <h3 className="removal-summary__heading">Removal summary</h3>
      <div className="removal-summary__grid">
        <section
          className="removal-summary-panel removal-summary-panel--remove"
          aria-labelledby="removal-summary-remove-heading"
        >
          <h4 id="removal-summary-remove-heading" className="removal-summary-panel__title">
            Will be removed
          </h4>
          <ul className="removal-summary-panel__list">
            {Object.entries(willRemove).map(([key, value]) => (
              <li key={key}>
                {formatImpactKey(key)}: <strong>{String(value)}</strong>
              </li>
            ))}
          </ul>
        </section>
        <section
          className="removal-summary-panel removal-summary-panel--preserve"
          aria-labelledby="removal-summary-preserve-heading"
        >
          <h4 id="removal-summary-preserve-heading" className="removal-summary-panel__title">
            Preserved for audit
          </h4>
          <ul className="removal-summary-panel__list">
            {Object.entries(willKeep).map(([key, value]) => (
              <li key={key}>
                {formatImpactKey(key)}: <strong>{String(value)}</strong>
              </li>
            ))}
          </ul>
        </section>
      </div>
      <p className="removal-summary__footnote muted">
        These rules are fixed to preserve audit history and prevent accidental data loss.
      </p>
    </div>
  );
}
